<template>
    <div>
        <div>
            <el-form :inline="true"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.serviceName" placeholder="请输入受理项目名称"  :clearable="true" class="query-input"></el-input>
                </el-form-item> 
                <el-form-item label="状态:">
                    <My-Select v-model="form.state" :objSelect="form.state" :options="options" :placeholder="placeholder" @changeSelct="changeSelct"></My-Select>                 
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="serviceEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="serviceEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>
        
        <el-dialog :title="title" :visible.sync="serviceDialog" :close-on-click-modal=false width="500px">
            <el-form :model="editorForm" :rules="rules" ref="editorForm" label-width="150px" style="text-align:left">
                <el-form-item label="服务项目名称:" prop="serviceName">
                    <el-input v-model="editorForm.serviceName" placeholder="请输入服务项目名称"></el-input>
                </el-form-item>
                <el-form-item label="状态:" prop="state" >
                    <el-switch v-model="editorForm.state"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                    <el-button @click="resetForm('editorForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import common from "../../../public/static/common.js";
export default { 

    name: 'serviceProject',
    data(){
        return{
            title:'',
            placeholder:'请选择查询状态',
            form:{
                serviceName:'',
                state:''
            },
            editorForm:{
                id:'',
                serviceName:'',
                createUser:'',
                state:true,
                modifyUser:''
            },
             // 列表配置
            configurationData:[
                {
                    title: '服务项目名称',
                    propertys: 'serviceName',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'stateName',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/dicServiceItem/page',
                param:this.form
            },
            serviceDialog:false,
            options:[
                {"key":'',"value":'全部'},
                {"key":'N',"value":'停用中'},
                {"key":'Y',"value":'使用中'}
            ],
            operationType:'',
            rules: {
                serviceName: [
                    { required: true, message: '请输入品类名称', trigger: 'blur' }
                ],
                state: [
                    { required: true, trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        serviceEditor(operationType,row){
            this.operationType=operationType;
            if(operationType=='update'){
                this.title="服务项目修改";
                this.editorForm.id=row.id;
                this.editorForm.serviceName=row.serviceName;
                if(row.state=='N'){
                    this.editorForm.state=false
                }else{
                    this.editorForm.state=true
                }
            }else{
                //添加
                this.title="服务项目新增";
                this.editorForm.state=true;
                this.editorForm=common.emptyModel(this.editorForm,["state"]);
            }
            this.serviceDialog=true;
        },
        query(){
            this.getTableParam.param=this.form
            this.$refs.myTable.query(1);
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);
                param.createUser=usercode;
                param.modifyUser=usercode;                 
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }
            if(this.operationType=='add'){
                url="/extwarapi/api/dicServiceItem/add";
            }else{
                url="/extwarapi/api/dicServiceItem/update";
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.post(url, param).then((resp) => {
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.serviceDialog=false;
                                    this.$refs["myTable"].query(1); 
                                }
                            });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                            });
                            return;
                        }  
               
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.serviceDialog=false;
            this.$refs[formName].resetFields();            
        },
        changeSelct(value){
            this.form.state=value;
        }
       
    }
 
}
</script>
<style lang="scss" scoped>

</style>